module.exports = __webpack_public_path__ + "static/media/my-homepage-photo.c01c6492.jpg";